import Swiper from 'swiper';
import HideOffscreenSlides from '../../components/modules/swiper-hide-offscreen';

const swiperClass = '.small-image-and-text__swiper';
const tabClass = '.small-image-and-text__tab-title ';
const tabActiveClass = 'small-image-and-text__tab-title--active';
const swipers = [];

function updateActiveSlide(swiper) {
  const tabs = swiper.el.querySelectorAll(tabClass);
  if (tabs.length) {
    tabs.forEach((tab) => {
      const slideIndex = Number(tab.dataset.slide);
      if (Number(swiper.realIndex) === slideIndex) {
        tab.classList.add(tabActiveClass);
      } else {
        tab.classList.remove(tabActiveClass);
      }
    });
  }
}
function initCarousel(carousel) {
  const swiper = new Swiper(carousel, {
    modules: [HideOffscreenSlides],
    loop: false,
    slidesPerView: 1,
    autoHeight: true,
    on: {
      slideChange(s) {
        updateActiveSlide(s);
      },
    },
  });

  const tabs = carousel.querySelectorAll(tabClass);
  if (tabs.length) {
    tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        const slideIndex = Number(tab.dataset.slide);

        swiper.slideTo(slideIndex);
      });
    });
  }

  swiper.init();
  swipers.push(swiper);

  return true;
}

const carousels = window.document.querySelectorAll(swiperClass);
if (carousels.length) {
  carousels.forEach((item) => {
    window.document.addEventListener('DOMContentLoaded', () => {
      initCarousel(item);
    });
  });
}
